import React, { Fragment } from 'react';
import NumericLabel from 'react-pretty-numbers';
import { Grid, TextField, InputAdornment, Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { LabelValueCard } from '../../../shared_elements';
import { getCurrencyFormat, getNumberDecimalFormat } from '../../../utils';
import { regexConstants } from '../../../constants/regEx';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { backendDateFormat, displayDateFormatShort, fieldDateFormat } from '../../../constants';
import moment from 'moment';
import { ABLInstance } from '../../../shared_elements/components';
const EngineEventInfo = ({engine, simulateEngine, simulationType, label, onFieldChange, financeError, updateErrorEngineField}) => {
  return(
    <div className="engine-basic-info">
      <Grid container spacing={1}>
        <Grid item md={6} sm={6}>
          <h4>Performance Restoration Shop Visit ( PRSV )</h4>
          <Grid container spacing={1}>
            <Grid item xs={12} md={10} lg={5}>
              <TextField
                disabled={simulationType === '1' || simulationType === '3'?true:false}
                id="engine_mr"
                label="MR Rate"
                fullWidth
                margin="none"
                value={simulationType === '3' ?simulateEngine.engine_mr :engine.engine_mr}
                InputLabelProps={{shrink: true}}
                error={financeError && financeError.engine_mr ? true : false}
                helperText={financeError && financeError.engine_mr ? financeError.engine_mr :''}
                onFocus={(e) => financeError && financeError.engine_mr ?  updateErrorEngineField('engine_mr','',label) : e.preventDefault()}
                onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'engine_mr', e.target.value, 'engines', label, 'engine'): e.preventDefault()}}
                InputProps={{
                  startAdornment: <InputAdornment position="start">US$</InputAdornment>,
                  endAdornment: <InputAdornment position="end">/ {engine.prsv_mr_interval}</InputAdornment>
                }}
                variant="outlined"
              />
              { simulationType === '3' && engine.engine_mr !== simulateEngine.engine_mr ?
                <p style={{color:'#ff0000', fontSize:'12px'}}>
                  <NumericLabel params={getCurrencyFormat({shortFormat:false})}>{engine.engine_mr}</NumericLabel> / {engine.prsv_mr_interval}
                  <Tooltip title="Original Value" arrow><InfoIcon style={{fontSize:'13px', position:'relative', top:'2px', left:'2px'}} /></Tooltip>
                </p>:null
              }
            </Grid>
            <Grid item xs={12} md={6}>
              <div style={{marginTop:'-16px'}}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDatePicker
                  required={engine.engine_escalation || engine.prsv_cost_escalation ? true :false}
                  disabled={simulationType === '1' || simulationType === '3' ? true : false}
                  margin="normal"
                  id="prsv_escalation_start_date"
                  minDate={ engine?.fund_date ? moment(engine?.fund_date) : null}
                  error={financeError && financeError.prsv_escalation_start_date ? true : false}
                  helperText={financeError && financeError.prsv_escalation_start_date ? financeError.prsv_escalation_start_date :''}
                  onFocus={(e) => financeError && financeError.prsv_escalation_start_date ?  updateErrorEngineField('prsv_escalation_start_date','',label) : e.preventDefault()}
                  label="Escalation Start Date"
                  format={fieldDateFormat}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={simulationType === '3' ? simulateEngine.prsv_escalation_start_date : engine.prsv_escalation_start_date}
                  onChange={(e) => { onFieldChange(e, 'prsv_escalation_start_date',  e ? moment(e).format(backendDateFormat) :e, 'engines', label, 'engine')}}
                  inputVariant="outlined"
                />
              </MuiPickersUtilsProvider>
              { simulationType === '3' && engine.prsv_escalation_start_date !== simulateEngine.prsv_escalation_start_date ? 
                  <p style={{color:'#ff0000', fontSize:'12px'}}>
                    {engine.prsv_escalation_start_date? moment(engine.prsv_escalation_start_date).format(displayDateFormatShort):'--'}
                    <Tooltip title="Original Value" arrow><InfoIcon style={{fontSize:'13px', position:'relative', top:'2px', left:'2px'}} /></Tooltip>
                  </p>:null
                }
              </div>
            </Grid>
            <Grid item xs={12} md={5} sm={6} lg={4}>
              <TextField
                disabled={simulationType === '1' || simulationType === '3'?true:false}
                id="engine_escalation"
                label="MR Rate Esc.(Annual)"
                fullWidth
                margin="none"
                value={simulationType === '3' ?simulateEngine.engine_escalation :engine.engine_escalation}
                InputLabelProps={{shrink: true}}
                onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) && e.target.value <= 100 ? onFieldChange(e, 'engine_escalation', e.target.value, 'engines', label, 'engine'): e.preventDefault()}}
                InputProps={{
                  endAdornment: <InputAdornment position="end">%</InputAdornment>
                }}
                variant="outlined"
              />
              {simulationType === '3' && engine.engine_escalation !==  simulateEngine.engine_escalation ?
                <p style={{color:'#ff0000', fontSize:'12px'}}>
                  {engine.engine_escalation}%
                  <Tooltip title="Original Value" arrow><InfoIcon style={{fontSize:'13px', position:'relative', top:'2px', left:'2px'}} /></Tooltip>
                </p>:null
              }
            </Grid>
            {ABLInstance?
            <Grid item xs={12} md={5} sm={6} lg={3}>
            <TextField
              disabled={simulationType === '1' || simulationType === '3'?true:false}
              id="engine_escalation"
              label="Cost Esc.(Annual)"
              fullWidth
              margin="none"
              value={simulationType === '3' ?simulateEngine.engine_escalation :engine.engine_escalation}
              InputLabelProps={{shrink: true}}
              onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) && e.target.value <= 100 ? onFieldChange(e, 'engine_escalation', e.target.value, 'engines', label, 'engine'): e.preventDefault()}}
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>
              }}
              variant="outlined"
            />
            {simulationType === '3' && engine.engine_escalation !==  simulateEngine.engine_escalation ?
              <p style={{color:'#ff0000', fontSize:'12px'}}>
                {engine.engine_escalation}%
                <Tooltip title="Original Value" arrow><InfoIcon style={{fontSize:'13px', position:'relative', top:'2px', left:'2px'}} /></Tooltip>
              </p>:null
            }
          </Grid>:
            <Grid item xs={12} md={5} sm={6} lg={3}>
              <TextField
                disabled={simulationType === '1' || simulationType === '3'?true:false}
                id="prsv_cost_escalation"
                label="Cost Esc.(Annual)"
                fullWidth
                margin="none"
                value={simulationType === '3' ? simulateEngine.prsv_cost_escalation :engine.prsv_cost_escalation}
                InputLabelProps={{shrink: true}}
                onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) && e.target.value <= 100 ? onFieldChange(e, 'prsv_cost_escalation', e.target.value, 'engines', label, 'engine'): e.preventDefault()}}
                InputProps={{
                  endAdornment: <InputAdornment position="end">%</InputAdornment>
                }}
                variant="outlined"
              />
              { simulationType === '3' && engine.prsv_cost_escalation !==  simulateEngine.prsv_cost_escalation ?
                <p style={{color:'#ff0000', fontSize:'12px'}}>
                  {engine.prsv_cost_escalation}%
                  <Tooltip title="Original Value" arrow><InfoIcon style={{fontSize:'13px', position:'relative', top:'2px', left:'2px'}} /></Tooltip>
                </p>:null
              }
            </Grid>}
          </Grid>
        </Grid>
        <Grid item md={6} sm={6}>
          <h4>LLP Replacement Shop Visit</h4>
          <Grid container spacing={1}>
            <Grid item xs={12} md={10} lg={5}>
              <TextField
                disabled={simulationType === '1' || simulationType === '3'?true:false}
                id="llp_mr"
                label="MR Rate"
                fullWidth
                margin="none"
                value={simulationType === '3' ?simulateEngine.llp_mr :engine.llp_mr}
                InputLabelProps={{shrink: true}}
                error={financeError && financeError.llp_mr ? true : false}
                helperText={financeError && financeError.llp_mr ? financeError.llp_mr : ''}
                onFocus={() => financeError && financeError.llp_mr && updateErrorEngineField('llp_mr','',label)}
                onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onFieldChange(e, 'llp_mr', e.target.value, 'engines', label, 'engine'): e.preventDefault()}}
                InputProps={{
                  startAdornment: <InputAdornment position="start">US$</InputAdornment>,
                  endAdornment: <InputAdornment position="end">/ {engine.llp_mr_interval}</InputAdornment>
                }}
                variant="outlined"
              />
              { simulationType === '3' && engine.llp_mr !==  simulateEngine.llp_mr ? 
                <p style={{color:'#ff0000', fontSize:'12px'}}>
                  <NumericLabel params={getCurrencyFormat({shortFormat:false})}>{engine.llp_mr}</NumericLabel> / {engine.llp_mr_interval}
                  <Tooltip title="Original Value" arrow><InfoIcon style={{fontSize:'13px', position:'relative', top:'2px', left:'2px'}} /></Tooltip>
                </p>:null
              }
            </Grid>
            <Grid item xs={12} md={6}>
              <div style={{marginTop:'-16px'}}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardDatePicker
                 required={engine.llp_escalation || engine.llp_cost_escalation ? true :false}
                  disabled={simulationType === '1' || simulationType === '3' ? true : false}
                  margin="normal"
                  id="llp_escalation_start_date"
                  label="Escalation Start Date"
                  minDate={ engine?.fund_date ? moment(engine?.fund_date) : null}
                  format={fieldDateFormat}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={simulationType === '3' ? simulateEngine.llp_escalation_start_date : engine.llp_escalation_start_date}
                  onChange={(e) => { onFieldChange(e, 'llp_escalation_start_date',  e ? moment(e).format(backendDateFormat) :e, 'engines', label, 'engine')}}
                  error={financeError && financeError.llp_escalation_start_date ? true : false}
                  helperText={financeError && financeError.llp_escalation_start_date ? financeError.llp_escalation_start_date :''}
                  onFocus={(e) => financeError && financeError.llp_escalation_start_date ?  updateErrorEngineField('llp_escalation_start_date','',label) : e.preventDefault()}
                  inputVariant="outlined"
                />
              </MuiPickersUtilsProvider>
              { simulationType === '3' && engine.llp_escalation_start_date !== simulateEngine.llp_escalation_start_date ? 
                  <p style={{color:'#ff0000', fontSize:'12px'}}>
                    {engine.llp_escalation_start_date? moment(engine.llp_escalation_start_date).format(displayDateFormatShort):'--'}
                    <Tooltip title="Original Value" arrow><InfoIcon style={{fontSize:'13px', position:'relative', top:'2px', left:'2px'}} /></Tooltip>
                  </p>:null
                }
              </div>
            </Grid>
            <Grid item xs={12} md={5} sm={6} lg={4}>
              <TextField
                disabled={simulationType === '1' || simulationType === '3'?true:false}
                id="llp_escalation"
                label="LLP Esc.(Annual)"
                fullWidth
                margin="none"
                value={simulationType === '3' ? simulateEngine.llp_escalation:engine.llp_escalation}
                InputLabelProps={{shrink: true}}
                onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) && e.target.value <= 100 ? onFieldChange(e, 'llp_escalation', e.target.value, 'engines', label, 'engine'): e.preventDefault()}}
                InputProps={{
                  endAdornment: <InputAdornment position="end">%</InputAdornment>
                }}
                variant="outlined"
              />
              { simulationType === '3' && engine.llp_escalation !==  simulateEngine.llp_escalation ? 
                <p style={{color:'#ff0000', fontSize:'12px'}}>
                  {engine.llp_escalation}%
                  <Tooltip title="Original Value" arrow><InfoIcon style={{fontSize:'13px', position:'relative', top:'2px', left:'2px'}} /></Tooltip>
                </p>:null
              }
            </Grid>
            {ABLInstance?
            <Grid item xs={12} md={5} sm={6} lg={3}>
            <TextField
              disabled={simulationType === '1' || simulationType === '3'?true:false}
              id="llp_escalation"
              label="Cost Esc.(Annual)"
              fullWidth
              margin="none"
              value={simulationType === '3' ? simulateEngine.llp_escalation:engine.llp_escalation}
              InputLabelProps={{shrink: true}}
              onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) && e.target.value <= 100 ? onFieldChange(e, 'llp_escalation', e.target.value, 'engines', label, 'engine'): e.preventDefault()}}
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>
              }}
              variant="outlined"
            />
            { simulationType === '3' && engine.llp_escalation !==  simulateEngine.llp_escalation ? 
              <p style={{color:'#ff0000', fontSize:'12px'}}>
                {engine.llp_escalation}%
                <Tooltip title="Original Value" arrow><InfoIcon style={{fontSize:'13px', position:'relative', top:'2px', left:'2px'}} /></Tooltip>
              </p>:null
            }
          </Grid>:
            <Grid item xs={12} md={5} sm={6} lg={3}>
              <TextField
                disabled={simulationType === '1' || simulationType === '3'?true:false}
                id="llp_cost_escalation"
                label="Cost Esc.(Annual)"
                fullWidth
                margin="none"
                value={engine.llp_cost_escalation}
                InputLabelProps={{shrink: true}}
                onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) && e.target.value <= 100 ? onFieldChange(e, 'llp_cost_escalation', e.target.value, 'engines', label, 'engine'): e.preventDefault()}}
                InputProps={{
                  endAdornment: <InputAdornment position="end">%</InputAdornment>
                }}
                variant="outlined"
              />
              { simulationType === '3' && engine.llp_cost_escalation !==  simulateEngine.llp_cost_escalation ?
                <p style={{color:'#ff0000', fontSize:'12px'}}>
                  {engine.llp_cost_escalation}%
                  <Tooltip title="Original Value" arrow><InfoIcon style={{fontSize:'13px', position:'relative', top:'2px', left:'2px'}} /></Tooltip>
                </p>:null
              }
            </Grid>}
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}
export default EngineEventInfo;
